<template>
  <GlobalNavigation />
  <BaseContainer>
    <div class="flex flex-col items-center justify-center py-24">
      <h1 class="h1">{{ $t('not_found.title') }}</h1>
      <p class="mt-6 text-lg">{{ $t('not_found.message') }}</p>

      <BaseButton class="mt-6" color="primary" to="/">
        {{ $t('not_found.back_to_home') }}
      </BaseButton>
    </div>
  </BaseContainer>
</template>

<script setup lang="ts">
  import { useHead } from '@unhead/vue';
  import { useI18n } from 'vue-i18n';

  import GlobalNavigation from '@/components/globals/GlobalNavigation.vue';
  import BaseButton from '@/components/ui/BaseButton.vue';
  import BaseContainer from '@/components/ui/BaseContainer.vue';

  const { t } = useI18n();

  useHead({
    title: t('not_found.title'),
    meta: [
      {
        name: 'description',
        content: t('not_found.message'),
      },
      {
        property: 'og:title',
        content: t('not_found.title'),
      },
      {
        property: 'og:description',
        content: t('not_found.message'),
      },
    ],
  });
</script>
